import { GreenhouseAppRow } from '../components/GreenhouseAppRow';
import type { AppRow } from '../type/AppRow';

export const greenhouseAppRow: AppRow = {
  key: 'greenhouse',
  name: 'Greenhouse',
  AppComponent: GreenhouseAppRow,
};
